import { render, staticRenderFns } from "./TodoProject.vue?vue&type=template&id=35b48205&"
import script from "./TodoProject.vue?vue&type=script&lang=js&"
export * from "./TodoProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports